import { render, staticRenderFns } from "./injuryhandle.vue?vue&type=template&id=0031f49a&"
import script from "./injuryhandle.vue?vue&type=script&lang=js&"
export * from "./injuryhandle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports